import Vue from "vue";
import Router from "vue-router";
import index from "@/components/Index";
Vue.use(Router);

export default new Router({
  routes: [{
      path: "/",
      redirect: "/index"
    },
    {
      path: "/index",
      component: index
    },
    {
      path: "/companIntroduction",
      component: () =>
        import("@/components/companIntroduction/CompanIntroduction")
    },
    {
      path: "/corporateCulture",
      component: () => import("@/components/corporateCulture/CorporateCulture")
    },
    {
      path: "/newsInformation",
      component: () => import("@/components/newsInformation/NewsInformation"),
      children: [{
          path: "",
          redirect: "companyDynamic"
        },
        {
          path: "companyDynamic",
          component: () => import("@/components/newsInformation/CompanyDynamic")
        },
        {
          path: "tradeNews",
          component: () => import("@/components/newsInformation/TradeNews")
        },
        {
          path: "companyDynamic/details/:id",
          component: () => import("@/components/newsInformation/NewsDetails")
        },
        {
          path: "tradeNews/details/:id",
          component: () =>
            import("@/components/newsInformation/TradeNewsDetails")
        },
        {
          path: "*",
          redirect: "companyDynamic"
        }
      ]
    },
    {
      path: "/contactUs",
      component: () => import("@/components/contactUs/ContactUs"),
    },
    {
      path: "/agreement",
      component: () => import("@/components/agreement/Agreement")
    },
    {
      path: "/privacyPolicy",
      component: () => import("@/components/privacyPolicy/PrivacyPolicy")
    },
    {
      path: "/joinUs",
      component: () => import("@/components/joinUs/JoinUs"),
      children: [{
          path: "campusRecruitment",
          component: () => import("@/components/joinUs/CampusRecruitment")
        },
        {
          path: "recommendation",
          component: () => import("@/components/joinUs/Recommendation")
        },
        {
          path: "socialRecruitment",
          component: () => import("@/components/joinUs/SocialRecruitment")
        },
        {
          path: "*",
          redirect: "socialRecruitment"
        },
        {
          path: "",
          redirect: "socialRecruitment"
        }
      ]
    },
    {
      path: "*",
      redirect: "/index"
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js